// Global voice kill-switch flag (client mirror of the server VOICE_ENABLED env).
// Set ONCE at App boot from the /api/auth/me `voice_enabled` boolean; read by the
// two voice entry points (Operator "Voice Mode" + AssistantPage "Call") to hide
// them when voice is disabled. The raw VOICE_ENABLED env value NEVER reaches the
// client — only this boolean does.
//
// It is a plain module singleton (not React state) because it's a global flag
// resolved during bootstrap BEFORE the shell (and thus the voice buttons) mount,
// so no reactivity is needed — the value is stable by the time anything reads it.
// This avoids drilling a global boolean through 4 unrelated component levels.
//
// The server /api/tts/synthesize + /api/voice/greeting cost wall is the real
// guarantee; hiding the buttons here is UI hygiene. Flipping VOICE_ENABLED=true
// restores everything with no code change.

let _voiceEnabled = false;

export function setVoiceEnabled(enabled: boolean): void {
  _voiceEnabled = enabled === true;
}

export function isVoiceEnabled(): boolean {
  return _voiceEnabled;
}
